<template>
  <div>
    <b-alert variant="secondary" show>
      <div
        style="display: flex; align-items: end; justify-content: end"
        class="mb-1 alert-heading"
      >
        <p class="mr-1"><b> Invoice Date Range (current month) :</b></p>
        <flat-pickr
          @input="onReportDate"
          v-model="reportDateRange"
          style="width: 400px"
          :config="{ mode: 'range', ...$flatPickrConfig, maxDate: new Date() }"
          placeholder="Select Month Range"
          class="form-control mr-1"
        />
        <b-button
          @click="showModal"
          class="mr-1"
          v-b-tooltip.hover
          title="apply filters"
          variant="secondary"
          size="sm"
          ><feather-icon style="cursor: pointer" icon="FilterIcon" size="23"
        /></b-button>
        <b-button
          v-b-tooltip.hover
          title="export as excel"
          variant="secondary"
          size="sm"
          @click="onExportExcel"
          ><feather-icon style="cursor: pointer" icon="DownloadIcon" size="23"
        /></b-button>
        <b-button
          variant="secondary"
          style="margin-left: 2%"
          @click="handleResetButtonClicked"
          >Reset</b-button
        >
      </div>
    </b-alert>
    <div v-if="filterApplied == true" style="margin-top: 2%; margin-bottom: 2%">
      <b-badge
        class="mr-1"
        variant="secondary"
        v-if="appliedFilters.selectedUniqueIdArray.length > 0"
      >
        Movie Unique ID : {{ appliedFilters.selectedUniqueIdArray.toString() }}
      </b-badge>
      <b-badge
        class="mr-1"
        variant="secondary"
        v-if="appliedFilters.selectedaccArray.length > 0"
      >
        Account : {{ appliedFilters.selectedaccArray.toString() }}
      </b-badge>
      <b-badge
        class="mr-1"
        variant="secondary"
        v-if="appliedFilters.selectedMovieArray.length > 0"
      >
        Movie : {{ appliedFilters.selectedMovieArray.toString() }}
      </b-badge>
      <b-badge
        class="mr-1"
        variant="secondary"
        v-if="appliedFilters.selectedTerArray.length > 0"
      >
        Territory : {{ appliedFilters.selectedTerArray.toString() }}
      </b-badge>
      <b-badge
        class="mr-1"
        variant="secondary"
        v-if="appliedFilters.selectedRightArray.length > 0"
      >
       Rights : {{ appliedFilters.selectedRightArray.toString() }}
      </b-badge>
      <b-badge
        class="mr-1"
        variant="secondary"
        v-if="appliedFilters.selectedInvDateRange"
      >
        Invoice Date : {{ appliedFilters.selectedInvDateRange }}
      </b-badge>
      <b-badge
        class="mr-1"
        variant="secondary"
        v-if="appliedFilters.selectedInvoiceArray.length > 0"
      >
        Invoice No : {{ appliedFilters.selectedInvoiceArray.toString() }}
      </b-badge>
      <b-badge
        class="mr-1"
        variant="secondary"
        v-if="appliedFilters.selectedCurrencyArray.length > 0"
      >
        Currency : {{ appliedFilters.selectedCurrencyArray.toString() }}
      </b-badge>
    </div>
    <div style="overflow-x: auto">
      <table ref="exportable_table">
        <tr style="background: lightgrey">
          <th>
            Invoice Number
            <hr />
            <b-button
              @click="showModal"
              v-b-tooltip.hover
              title="apply filters"
              variant="secondary"
              size="sm"
              ><feather-icon
                style="cursor: pointer"
                icon="FilterIcon"
                size="15"
            /></b-button>
          </th>

          <th>
            Account
            <hr />

            <b-button
              @click="showModal"
              v-b-tooltip.hover
              title="apply filters"
              variant="secondary"
              size="sm"
              ><feather-icon
                style="cursor: pointer"
                icon="FilterIcon"
                size="15"
            /></b-button>
          </th>

          <th>
            Movie Unique ID
            <hr />
            <b-button
              @click="showModal"
              v-b-tooltip.hover
              title="apply filters"
              variant="secondary"
              size="sm"
              ><feather-icon
                style="cursor: pointer"
                icon="FilterIcon"
                size="15"
            /></b-button>
          </th>
          <th>
            Movie
            <hr />
            <b-button
              @click="showModal"
              v-b-tooltip.hover
              title="apply filters"
              variant="secondary"
              size="sm"
              ><feather-icon
                style="cursor: pointer"
                icon="FilterIcon"
                size="15"
            /></b-button>
          </th>
          <th>Licensee</th>
          <th>
            Territory
            <hr />
            <b-button
              @click="showModal"
              v-b-tooltip.hover
              title="apply filters"
              variant="secondary"
              size="sm"
              ><feather-icon
                style="cursor: pointer"
                icon="FilterIcon"
                size="15"
            /></b-button>
          </th>
          <th>
            Rights
            <hr />
            <b-button
              @click="showModal"
              v-b-tooltip.hover
              title="apply filters"
              variant="secondary"
              size="sm"
              ><feather-icon
                style="cursor: pointer"
                icon="FilterIcon"
                size="15"
            /></b-button>
          </th>

          <th>Accounting Code</th>
          <th>Invoice Date</th>
          <th>Payment Date</th>
          <th>
            Currency
            <hr />

            <b-button
              @click="showModal"
              v-b-tooltip.hover
              title="apply filters"
              variant="secondary"
              size="sm"
              ><feather-icon
                style="cursor: pointer"
                icon="FilterIcon"
                size="15"
            /></b-button>
          </th>
          <th>Invoice Net Amount (excl. VAT)</th>
          <th>VAT (Accounting Code)</th>
          <th>VAT Percent</th>
          <th>VAT Amount</th>
          <th>Invoice Amount (incl. VAT)</th>
          <th>Exchange Rate</th>
          <th>Total CHF</th>
        </tr>
        <tr
          v-for="(item, index) in paginatedData"
          :key="index"
          :style="
            item.invoice_unique_id &&
            item.invoice_unique_id.toString().includes('Total')
              ? 'background:lightGrey;border-bottom:3px solid grey '
              : ''
          "
        >
          <td>
            <a
              @click="
                () =>
                  (invId = item.revenue_invoice_id
                    ? item.revenue_invoice_id
                    : null)
              "
              v-b-modal.invModal
              ><u>{{ item.invoice_unique_id }}</u></a
            >
          </td>

          <td>{{ item.iban }}</td>
          <td>{{ item.uniqueId }}</td>
          <td>{{ item.title }}</td>
          <td>{{ item.company }}</td>

          <td>
            {{ item.territory }}
          </td>
          <td>{{ item.rightIdentifier }}</td>
          <td>{{ item.sub_accounting_code }}</td>

          <td>{{ item.invDate ? item.invDate : "" }}</td>
          <td>{{ item.payDate ? item.payDate : "" }}</td>
          <td>{{ item.selectedCurrency }}</td>
          <td style="text-align: right">
            {{ formatCurrency(item.share_net) }}
          </td>
          <td>{{ item.vatCode }}</td>
          <td>{{ item.vatPercent }}</td>
          <td style="text-align: right">{{ formatCurrency(item.vatAmt) }}</td>
          <td style="text-align: right">{{ formatCurrency(item.totalAmt) }}</td>
          <td style="text-align: right">
            {{ item.exchange_rate ? formatExchangeRate(item.exchange_rate) : 1 }}
          </td>
          <td style="text-align: right">
            {{ item.base_chf_total ? formatCurrency(item.base_chf_total) : "" }}
          </td>
        </tr>
      </table>
    </div>
    <div>
      <b-modal
        no-close-on-backdrop
        ref="my-modal"
        hide-footer
        title="Report Filters"
      >
        <div class="d-block text-left">
          <b-form-group id="Invoice" label="Invoice Numbers">
            <v-select
              :close-on-select="true"
              multiple
              v-model="filters.selectedInvoiceArray"
              placeholder="Select"
              label="value"
              :reduce="(inv) => inv.id"
              :options="invoiceNumbersArray"
            />
          </b-form-group>
          <b-form-group id="Account" label="Account">
            <v-select
              :close-on-select="true"
              multiple
              v-model="filters.selectedaccArray"
              placeholder="Select"
              label="value"
              :reduce="(inv) => inv.id"
              :options="accNumbersArray"
            />
          </b-form-group>

          <b-form-group id="MovieUniqueID" label="Movie Unique ID">
            <v-select
              :close-on-select="true"
              multiple
              v-model="filters.selectedUniqueIdArray"
              placeholder="Select"
              label="value"
              :reduce="(inv) => inv.id"
              :options="uniqueIdArray"
            />
          </b-form-group>
          <b-form-group id="Movie" label="Movie">
            <v-select
              :close-on-select="true"
              multiple
              v-model="filters.selectedMovieArray"
              placeholder="Select"
              label="value"
              :reduce="(inv) => inv.id"
              :options="movieArray"
            />
          </b-form-group>
          <b-form-group id="Territory" label="Territory">
            <v-select
              :close-on-select="true"
              multiple
              v-model="filters.selectedTerArray"
              placeholder="Select"
              label="value"
              :reduce="(inv) => inv.id"
              :options="territoryArray"
            />
          </b-form-group>
          <b-form-group id="Rights" label="Rights">
            <v-select
              :close-on-select="true"
              multiple
              v-model="filters.selectedRightArray"
              placeholder="Select"
              label="value"
              :reduce="(inv) => inv.id"
              :options="rightArray"
            />
          </b-form-group>
          <b-form-group id="Currency" label="Currency">
            <v-select
              :close-on-select="true"
              multiple
              v-model="filters.selectedCurrencyArray"
              placeholder="Select"
              label="value"
              :reduce="(inv) => inv.id"
              :options="currencyArray"
            />
          </b-form-group>

          <!-- <b-form-group label="Invoice Date Range">
            <flat-pickr
              :config="{ mode: 'range', ...$flatPickrConfig }"
              placeholder="Select"
              class="form-control"
              v-model="filters.selectedInvDateRange"
            />
          </b-form-group> -->
        </div>
        <b-button
          class="mt-3"
          variant="outline-danger"
          block
          @click="onApplyFilters"
          >Apply Filters</b-button
        >
        <b-button variant="outline-info" block @click="handleResetButtonClicked"
          >Reset Filters</b-button
        >
      </b-modal>
    </div>
    <b-modal v-if="invId" size="xl" id="invModal" title="Invoice"
      ><preview-invoice :invId="invId" />
    </b-modal>
    <div style="margin-top: 30px; padding-bottom: 50px">
      <b-row>
        <b-col
          class="d-flex align-items-end justify-content-end justify-content-sm-center"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BTabs,
  BTab,
  BCard,
  BButton,
  VBTooltip,
  BModal,
  BFormGroup,
  BBadge,
  BAlert,
} from "bootstrap-vue";
import { GetBookKeepingRevenueReport } from "@/apiServices/BookkeepingServices";
import moment from "moment";
import { formatCurrency,formatExchangeRate } from "@/utils/helpers";
import qs from "qs";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import PreviewInvoice from "@/views/pages/Revenue/PreviewInvoice.vue";
import { toHandlers } from "@vue/runtime-dom";
export default {
  data() {
    return {
      filterApplied: false,
      reportDateRange: null,
      reportFromDate: null,
      reportToDate: null,
      invoiceNumbersArray: [],
      movieArray: [],
      territoryArray: [],
      rightArray: [],
      uniqueIdArray: [],
      accNumbersArray: [],
      currencyArray: [],
      mainData: [],
      totalData: [],
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      filters: {
        selectedInvoiceArray: [],
        selectedaccArray: [],
        selectedCurrencyArray: [],
        selectedMovieArray: [],
        selectedTerArray: [],
        selectedUniqueIdArray: [],
        selectedRightArray: [],
        selectedInvDateRange: null,
      },
      appliedFilters:{
        selectedInvoiceArray: [],
        selectedaccArray: [],
        selectedCurrencyArray: [],
        selectedMovieArray: [],
        selectedTerArray: [],
        selectedUniqueIdArray: [],
        selectedRightArray: [],
        selectedInvDateRange: null,
      },
      BASE_URL: process.env.VUE_APP_BASEURL,
      moment: moment,
      tabIndex: 0,
      bookKeepingReportData: [],
      actualBookKeepingReportData: [],
      invId: null,
      applyFilterClicked: false,
    };
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  components: {
    BTabs,
    BTab,
    BCard,
    FeatherIcon,
    BButton,
    VBTooltip,
    BModal,
    BFormGroup,
    vSelect,
    flatPickr,
    BBadge,
    PreviewInvoice,
    BAlert,
  },
  computed: {
    paginatedData() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      const currentPageData = this.mainData.slice(start, end);
      return [...currentPageData, ...this.totalData];
    },
  },
  beforeMount() {
    this.filterApplied = false;
    let today = moment().format("YYYY-MM-DD");
    const isFirstDayOfMonth = moment().date() === 1;
    let previous;
    if (isFirstDayOfMonth) {
      // If today is the 1st day of the month, set `previous` to 15 days back from the start of the month
      previous = moment()
        .startOf("month")
        .subtract(15, "days")
        .format("YYYY-MM-DD");
    } else {
      // If today is not the 1st day of the month, set `previous` to the start of the current month
      previous = moment().startOf("month").format("YYYY-MM-DD");
    }
    this.reportDateRange = previous + " to " + today;

    this.reportFromDate = previous;
    this.reportToDate = today;
    this.getBookkeepingReport();
  },
  methods: {
    formatCurrency,
    formatExchangeRate,
    handleResetButtonClicked() {
      this.currentPage = 1; 
      console.log("Reset button is clicked");
      localStorage.removeItem("filtersReportDateRangeBookkeepingRevenueReport");
      localStorage.removeItem("bookkeepingRevenueFilters");
      this.filterApplied = false;
      // let today = moment().format("YYYY-MM-DD");
      // let previous = moment().startOf("month").format("YYYY-MM-DD");
      // this.reportDateRange = previous + " to " + today;

      // this.reportFromDate = moment().startOf("month").format("YYYY-MM-DD");
      // this.reportToDate = moment().endOf("month").format("YYYY-MM-DD");
      const isFirstDayOfMonth = moment().date() === 1;
      if (isFirstDayOfMonth) {
        this.reportDateRange = `${moment()
          .subtract(15, "days")
          .format("YYYY-MM-DD")} to ${moment().format("YYYY-MM-DD")}`;
        this.reportFromDate = moment()
          .subtract(15, "days")
          .format("YYYY-MM-DD");
        this.reportToDate = moment().format("YYYY-MM-DD");
      } else {
        this.reportDateRange = `${moment()
          .startOf("month")
          .format("YYYY-MM-DD")} to ${moment().format("YYYY-MM-DD")}`;
        this.reportFromDate = moment().startOf("month").format("YYYY-MM-DD");
        this.reportToDate = moment().format("YYYY-MM-DD");
      }

      this.filters = {
        selectedInvoiceArray: [],
        selectedaccArray: [],
        selectedCurrencyArray: [],
        selectedMovieArray: [],
        selectedTerArray: [],
        selectedUniqueIdArray: [],
        selectedRightArray: [],
      }
      this.invoiceNumbersArray = [] ;
      this.movieArray = [] ;
      this.territoryArray = [] ;
      this.rightArray = [] ;  
      this.uniqueIdArray = [] ; 
      this.accNumbersArray = [] ;
      this.currencyArray = [] ;
      this.getBookkeepingReport();
    },
    // onReportDate() {
    //   if (this.reportDateRange) {
    //     let from = null;
    //     let to = null;
    //     if (this.reportDateRange.split("to").length > 1) {
    //       from = new Date(this.reportDateRange.split("to")[0]);
    //       to = new Date(this.reportDateRange.split("to")[1]);
    //     } else {
    //       from = new Date(this.reportDateRange.split("to")[0]);
    //       to = new Date(this.reportDateRange.split("to")[0]);
    //     }

    //     this.reportFromDate = `${from.getFullYear()}-${(
    //       "0" +
    //       (from.getMonth() + 1)
    //     ).slice(-2)}-${("0" + from.getDate()).slice(-2)}`;

    //     // this.reportToDate = `${to.getFullYear()}-${(
    //     //   "0" +
    //     //   (to.getMonth() + 1)
    //     // ).slice(-2)}-${(
    //     //   "0" + (to.getDate() + to.getMonth() == 2 ? 28 : 30)
    //     // ).slice(-2)}`;
    //     this.reportToDate = moment(to).add(1, "days").format("YYYY-MM-DD");
    //     localStorage.setItem(
    //       "filtersReportDateRangeBookkeepingRevenueReport",
    //       JSON.stringify({
    //         reportDateRange: this.reportDateRange,
    //         // pagination: this.pagination,
    //       })
    //     );
    //     console.log("Value saved to local storage:", {
    //       reportDateRange: this.reportDateRange,
    //     });
    //     this.getBookkeepingReport();
    //   }

    //   //       const parsedDate = moment(dateString, 'MMM-YYYY');

    //   // // Step 2: Format the parsed date into YYYY-MM-DD format
    //   // const formattedDate = parsedDate.format('YYYY-MM-DD');
    // },

    onReportDate() {
      if (this.reportDateRange) {
        this.currentPage = 1; 
        let from = null;
        let to = null;

        // Check if today is the 1st day of the month
        const today = new Date();
        const isFirstDayOfMonth = today.getDate() === 1;

        // if (isFirstDayOfMonth) {
        //   // If today is the 1st day of the month, set `from` to 15 days back
        //   from = new Date(today);
        //   from.setDate(today.getDate() - 15);

        //   // Set `to` to today
        //   to = new Date(today);

        //   // Update the reportDateRange to reflect the new range
        //   this.reportDateRange = `${from.toISOString().split("T")[0]} to ${
        //     to.toISOString().split("T")[0]
        //   }`;
        // } else {
        //   // If not the 1st day of the month, proceed with the original logic
        //   if (this.reportDateRange.split("to").length > 1) {
        //     from = new Date(this.reportDateRange.split("to")[0]);
        //     to = new Date(this.reportDateRange.split("to")[1]);
        //   } else {
        //     from = new Date(this.reportDateRange.split("to")[0]);
        //     to = new Date(this.reportDateRange.split("to")[0]);
        //   }
        // }
        from = this.reportDateRange.split("to")[0];
        to = this.reportDateRange.split("to")[1];

        // Format the `from` and `to` dates
        // this.reportFromDate = `${from.getFullYear()}-${(
        //   "0" +
        //   (from.getMonth() + 1)
        // ).slice(-2)}-${("0" + from.getDate()).slice(-2)}`;
        this.reportFromDate = from

        // this.reportToDate = moment(to).add(1, "days").format("YYYY-MM-DD");
        this.reportToDate = to

        // Save the updated reportDateRange to local storage
        localStorage.setItem(
          "filtersReportDateRangeBookkeepingRevenueReport",
          JSON.stringify({
            reportDateRange: this.reportDateRange,
            // pagination: this.pagination,
          })
        );

        console.log("Value saved to local storage:", {
          reportDateRange: this.reportDateRange,
        });
        this.invoiceNumbersArray = [] ;
        this.movieArray = [] ;
        this.territoryArray = [] ;
        this.rightArray = [] ;
        this.uniqueIdArray = [] ;
        this.accNumbersArray = [] ;
        this.currencyArray = [] ;
        this.getBookkeepingReport();
      }
    },
    onResetFilters() {
      this.currentPage = 1;
      this.filterApplied = false;
      this.uniqueIdArray = [];
      this.territoryArray = [];
      this.rightArray = [];
      this.movieArray = [];
      this.uniqueIdArray = [];
      this.invoiceNumbersArray = [];
      this.licensorArray = [];
      this.currencyArray = [];
      this.filters = {
        selectedInvoiceArray: [],

        selectedInvDateRange: null,
        selectedMovieArray: [],
        selectedUniqueIdArray: [],
        selectedRightArray: [],
        selectedTerArray: [],
      };
      localStorage.removeItem("filtersReportDateRangeBookkeepingRevenueReport");
      localStorage.removeItem("bookkeepingRevenueFilters");
      let today = moment().format("YYYY-MM-DD");
      let previous = moment().startOf("month").format("YYYY-MM-DD");
      this.reportDateRange = previous + " to " + today;

      this.reportFromDate = moment().startOf("month").format("YYYY-MM-DD");
      this.reportToDate = moment().endOf("month").format("YYYY-MM-DD");
      this.getBookkeepingReport();
    },
    onApplyFilters() {
      this.currentPage = 1;
      this.filterApplied = true;
      this.applyFilterClicked = false ;
      this.appliedFilters = JSON.parse(JSON.stringify(this.filters))
      localStorage.setItem(
        "bookkeepingRevenueFilters",
        JSON.stringify(this.appliedFilters)
      );
      this.getBookkeepingReport();
      this.$refs["my-modal"].hide();
    },

    onExportExcel() {
      let url = null;
      let excelName = "";
      let payload = {
        bookKeepingReportData: this.bookKeepingReportData,
        uniqueId: this.filters.selectedUniqueIdArray
          ? this.filters.selectedUniqueIdArray.toString()
          : "",
        mvi: this.filters.selectedMovieArray
          ? this.filters.selectedMovieArray.toString()
          : "",
        invDtRange: this.filters.selectedInvDateRange,
        terr: this.filters.selectedTerArray
          ? this.filters.selectedTerArray.toString()
          : "",
        right: this.filters.selectedRightArray
          ? this.filters.selectedRightArray.toString()
          : "",
        invNumbers: this.filters.selectedInvoiceArray
          ? this.filters.selectedInvoiceArray.toString()
          : "",
      };

      url = this.BASE_URL + `/bookkeeping/exportBookKeepingRevenueReport`;

      fetch(url, {
        method: "POST",
        headers: {
          "content-type": "application/Json",
          authorization: localStorage.getItem("access_token"),
          "x-access-token": localStorage.getItem("access_token"),
        },
        body: JSON.stringify(payload),
      })
        .then((response) => response.blob())
        .then((blob) => {
          const anchorElement = document.createElement("a");
          document.body.appendChild(anchorElement);
          anchorElement.style.display = "none";
          excelName = "BookKeepingRevenueReport.xlsx";
          var url = window.URL.createObjectURL(blob);
          anchorElement.href = url;
          anchorElement.download = excelName;
          anchorElement.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => {
          console.log(err, "error in onExportExcel");
        });
    },
    async getBookkeepingReport() {
      try {
        this.bookKeepingReportData = [];
        this.loadBookkeepingRevenueReportFilters();
        const response = await GetBookKeepingRevenueReport({
          reportFromDate: this.reportFromDate,
          reportToDate: this.reportToDate,
          filters: this.filters,
        });
        if (response.data.status) {
          const allData = response.data.data;
          this.mainData = allData.slice(0, -3);
          this.totalData = allData.slice(-3);
          this.totalRows = this.mainData.length;
          this.bookKeepingReportData = response.data.data;

          this.actualBookKeepingReportData = response.data.data;

          let addedInv = [];
          let addedMovie = [];
          let addedUnId = [];
          let addedTer = [];
          let addedRt = [];
          let addedCurrency = [];
          let addedAcc = [];
          for (let item of this.bookKeepingReportData) {
            if (
              item.invoice_unique_id &&
              item.invoice_unique_id != "Total" &&
              item.invoice_unique_id != "Grand Total"
            ) {
              if (!addedInv.includes(item.invoice_unique_id)) {
                let obj = {
                  id: item.invoice_unique_id,
                  value: item.invoice_unique_id,
                };
                const isDuplicateInvoiceNumbers = this.invoiceNumbersArray.some(
                  (existingItem) => existingItem.id === item.invoice_unique_id
                );
                const isInteger = Number.isInteger(
                  Number(item.invoice_unique_id)
                );
                if (!isDuplicateInvoiceNumbers && isInteger) {
                  this.invoiceNumbersArray.push(obj);
                  addedInv.push(item.invoice_unique_id);
                }
              }
              if (!addedMovie.includes(item.title)) {
                let obj1 = {
                  id: item.title,
                  value: item.title,
                };
                const isDuplicateMovie = this.movieArray.some(
                  (existingItem) => existingItem.id === item.title
                );
                const trimmedMovieIdentifier = item.title
                  ? item.title.trim()
                  : "";
                if (
                  trimmedMovieIdentifier !== "" &&
                  !addedMovie.includes(trimmedMovieIdentifier) &&
                  !isDuplicateMovie
                ) {
                  let objR = {
                    id: trimmedMovieIdentifier,
                    value: trimmedMovieIdentifier,
                  };
                  this.movieArray.push(objR);
                  addedMovie.push(trimmedMovieIdentifier);
                }
              }
              if (!addedUnId.includes(item.uniqueId)) {
                let objU = {
                  id: item.uniqueId,
                  value: item.uniqueId,
                };
                const isDuplicateUniqueId = this.uniqueIdArray.some(
                  (existingItem) => existingItem.id === item.uniqueId
                );
                const trimmedUniqueIdIdentifier = item.uniqueId
                  ? item.uniqueId.trim()
                  : "";
                if (
                  trimmedUniqueIdIdentifier !== "" &&
                  !addedUnId.includes(trimmedUniqueIdIdentifier) &&
                  !isDuplicateUniqueId
                ) {
                  this.uniqueIdArray.push(objU);
                  addedUnId.push(item.uniqueId);
                }
              }

              if (!addedRt.includes(item.rightIdentifier)) {
                let objR = {
                  id: item.rightIdentifier,
                  value: item.rightIdentifier,
                };
                const trimmedRightIdentifier = item.rightIdentifier
                  ? item.rightIdentifier.trim()
                  : "";

                const isDuplicateRightArray = this.rightArray.some(
                  (existingItem) => existingItem.id === item.rightIdentifier
                );

                if (
                  trimmedRightIdentifier !== "" &&
                  !addedRt.includes(trimmedRightIdentifier) &&
                  !isDuplicateRightArray
                ) {
                  this.rightArray.push(objR);
                  addedRt.push(item.rightIdentifier);
                }
              }

              if (!addedTer.includes(item.territory)) {
                let objT = {
                  id: item.territory,
                  value: item.territory,
                };
                const trimmedTerrIdentifier = item.territory
                  ? item.territory.trim()
                  : "";
                const isDuplicateTerritoryArray = this.territoryArray.some(
                  (existingItem) => existingItem.id === item.territory
                );
                if (
                  trimmedTerrIdentifier !== "" &&
                  !addedTer.includes(trimmedTerrIdentifier) &&
                  !isDuplicateTerritoryArray
                ) {
                  this.territoryArray.push(objT);
                  addedTer.push(item.territory);
                }
              }

              if (!addedAcc.includes(item.iban)) {
                let obj66 = {
                  id: item.iban,
                  value: item.iban,
                };
                const trimmedAccIdentifier = item.iban ? item.iban.trim() : "";
                const isDuplicateAccountNumbers = this.accNumbersArray.some(
                  (existingItem) => existingItem.id === item.iban
                );
                if (
                  !addedAcc.includes(trimmedAccIdentifier) &&
                  trimmedAccIdentifier !== "" &&
                  !isDuplicateAccountNumbers
                ) {
                  this.accNumbersArray.push(obj66);
                  addedAcc.push(item.iban);
                }
              }
              if (item.selectedCurrency) {
                if (!addedCurrency.includes(item.selectedCurrency)) {
                  let obj2 = {
                    id: item.selectedCurrency,
                    value: item.selectedCurrency,
                  };
                  const isDuplicateCurrencyArray = this.currencyArray.some(
                    (existingItem) => existingItem.id === item.selectedCurrency
                  );
                  const trimmedCurrencyIdentifier = item.selectedCurrency
                    ? item.selectedCurrency.trim()
                    : "";
                  if (
                    !addedCurrency.includes(trimmedCurrencyIdentifier) &&
                    trimmedCurrencyIdentifier !== "" &&
                    !isDuplicateCurrencyArray
                  ) {
                    this.currencyArray.push(obj2);
                    addedCurrency.push(item.selectedCurrency);
                  }
                }
              }
            }
          }
        }
        console.log(response, "response");
        // if (this.filterApplied) {
        //   this.onApplyFilters();
        // }
      } catch (error) {
        console.log("Error in getBookkeepingReport", error);
      }
    },
    showModal() {
      this.$refs["my-modal"].show();
    },
    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ["bg-primary", "text-light"];
      } else {
        return ["bg-outline-primary", "text-info"];
      }
    },
    loadBookkeepingRevenueReportFilters() {
      let bookkeepingFilters = localStorage.getItem(
        "bookkeepingRevenueFilters"
      );
      if (bookkeepingFilters) {
        let parsedBookkeepingFilters = JSON.parse(bookkeepingFilters);
        this.filters = parsedBookkeepingFilters;
        this.appliedFilters = this.filters ;
      }
      if (
        this.filters.selectedInvoiceArray.length > 0 ||
        this.filters.selectedRightArray.length > 0 ||
        this.filters.selectedMovieArray.length > 0 ||
        this.filters.selectedTerArray.length > 0 ||
        this.filters.selectedUniqueIdArray.length > 0 ||
        this.filters.selectedaccArray.length > 0 ||
        this.filters.selectedCurrencyArray.length > 0
      ) {
        this.filterApplied = true;
      }
    },
    loadReportToDateData() {
      const reportDateRange = localStorage.getItem(
        "filtersReportDateRangeBookkeepingRevenueReport"
      );
      if (reportDateRange) {
        const obj = JSON.parse(reportDateRange);
        // this.pagination = obj.pagination;
        this.reportDateRange = obj.reportDateRange;
        this.$forceUpdate();
      }
      console.log(`The date range is ${this.reportDateRange}`);
      // this.getBookkeepingReport();
    },
  },
  mounted() {
    this.loadReportToDateData();
    this.loadBookkeepingRevenueReportFilters();
    // this.$store.dispatch("master/setVendorsMaster");
    // this.$store.dispatch("master/setMoviesMaster");

    // this.$store.dispatch("master/setLabelMaster", { key: labels.language });

    // // Tree Data
    // this.$store.dispatch("master/setLabelTreeMaster", {
    //   key: labels.rights_tree,
    //   master: labels.rights,
    //   sub_master: labels.sub_right,
    // });
    // this.$store.dispatch("master/setLabelTreeMaster", {
    //   key: labels.territory_tree,
    //   master: labels.territory,
    //   sub_master: labels.sub_territory,
    // });
  },
};
</script>

<style lang="scss" scoped>
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  color: #000;
  border: 2px solid #dddddd;
  text-align: left;
  padding: 8px;
  font-weight: 550;
  font-weight: 400;
}
tr:hover {
  background-color: yellow;
}
</style>
